/**
 * @file coaching.enum.ts
 * @description Specialized coaching domain constants.
 * @standard Migrated from TypeScript `enum` to `as const` object for better type inference and DX.
 */

export const CoachingSessionStatus = {
  Confirmed: 'CONFIRMED',
  Completed: 'COMPLETED',
  Cancelled: 'CANCELLED'
} as const;

export type CoachingSessionStatus = (typeof CoachingSessionStatus)[keyof typeof CoachingSessionStatus];
